import React from 'react';
export function Footer() {
  return <footer className="bg-[#10284D] px-4 py-12 text-center text-sm text-white/60" data-id="element-68" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-69" data-mp="3gg0yw2enzvx4">
        <div className="mb-3 font-serif text-xl font-bold text-white" data-id="element-70" data-mp="3gh3n22klrk9c">♫ MÚSICA LISTA</div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/50" data-id="element-71" data-mp="32lrnnhvi55m3">
          El pack completo de docencia musical para escuelas, docentes y familias de toda
          Latinoamérica.
        </p>
        <nav aria-label="Legal" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-72" data-mp="3ud7iu0b4k0nx">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-73" data-mp="3lf582t1l9tng">
            Términos
          </a>
          <a href="#contacto" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-74" data-mp="3qbvnrf9hen8c">
            Contacto
          </a>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-75" data-mp="2ey9yzv7jannc">
            Política de Privacidad
          </a>
        </nav>
        <p data-id="element-76" data-mp="3la27gozaktsl">© 2026 Música Lista — Todos los derechos reservados.</p>
      </div>
    </footer>;
}